import type { Observable } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type {
  SignupAttempt,
  User,
  UserFilter,
  UserTransfer,
  UserWallet,
} from '@domain/models/user.model';

/**
 * Contract owned by the domain layer. The data layer supplies the implementation,
 * so features never depend on HTTP details.
 */
export abstract class UserRepository {
  abstract list(query: PageQuery, filter?: UserFilter): Observable<PagedResult<User>>;

  abstract listCancelRequests(
    query: PageQuery,
    active?: boolean,
  ): Observable<PagedResult<User>>;

  abstract listSignupAttempts(query: PageQuery): Observable<PagedResult<SignupAttempt>>;

  abstract getById(id: number): Observable<User>;

  abstract getWallet(id: number): Observable<UserWallet>;

  abstract getTransfers(id: number, query: PageQuery): Observable<PagedResult<UserTransfer>>;

  abstract updateTag(userId: number, userTagId: number): Observable<void>;

  abstract resetPin(userId: number, pin: string): Observable<void>;

  abstract addAdminCredit(userId: number, amount: number): Observable<void>;

  abstract softDelete(userId: number): Observable<void>;
}
